import Dashboard from './Dashboard';

const App = () => {
	return <Dashboard />;
};

export default App;
